module.exports = __webpack_public_path__ + "img/fushimi-HP-010.91069517.jpg";